import {CustomField} from './custom-field';

export class CustomFieldCollection {
    private totalItems: number = 0;
    private customFields: CustomField[] = [];

    setTotalItems(totalItems: number) {
        this.totalItems = totalItems;
    }

    setCustomFields(customFields: CustomField[]) {
        this.customFields = customFields;
    }

    getTotalItems(): number {
        return this.totalItems;
    }

    getCustomFields(): CustomField[] {
        return this.customFields;
    }
}
